import { render, staticRenderFns } from "./ShiftsCounterReminder.vue?vue&type=template&id=55c155c7&scoped=true&"
import script from "./ShiftsCounterReminder.vue?vue&type=script&lang=js&"
export * from "./ShiftsCounterReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c155c7",
  null
  
)

export default component.exports